import React from 'react'
import ErrorPage from 'src/views/pages/ErrorPage'

const Page500 = () => <ErrorPage code="500" />

export default Page500
